import React from "react";
import Forbidden from "../../components/pages/Forbidden";
import Spinner from "../../components/utils/Spinner";
import { SideMenu } from "../../components/utils/SideMenu/SideMenu.container";
import { SideMenuArrowContext, SideMenuCloseArrow } from "../../components/utils/SideMenu/SideMenuCloseArrow";
import SubTopbar from "../../components/utils/SubTopbar";
import TopBar from "../../components/utils/TopBar";
import ClassAnalytics from "./ClassAnalytics";
import ScormPackageAnalytics from "./ScormPackageAnalytics";
import { IAnalyticsProps } from "./types";

export const AnalyticsComponent: React.FC<IAnalyticsProps> = ({
  location,
  authenticationState: { isAuthenticated, isKnown },
  isAdmin,
  match,
  userName,
  organizationName,
}) => {
  if (!isKnown || !isAdmin) {
    return <Spinner />;
  }

  if (!isAuthenticated) {
    return <Forbidden />;
  }

  const {
    params: { courseId, objectId, type },
  } = match;

  const [menuExpanded, setMenuExpanded] = React.useState(true);
  const { isOpen } = React.useContext(SideMenuArrowContext);
  const toggleMenu = () => setMenuExpanded(!menuExpanded);
  const setSideMenuTabAsSelected = () => {
    const element = document.getElementById("dashboard-link");
    element?.setAttribute("class", "selected");
  };

  React.useEffect(setSideMenuTabAsSelected, [location]);

  return (
    <>
      <TopBar fitContent={false} showToggleMenu={true} onToggleMenuClick={toggleMenu} userName={userName} />
      <SideMenuCloseArrow />
      <SideMenu
        expanded={menuExpanded}
        isOpen={isOpen}
        onClose={toggleMenu}
        organizationName={organizationName}
        userName={userName}
      />
      <SubTopbar withSidebar={true} isOpen={isOpen}>
        {type === "class" && <ClassAnalytics location={location} courseId={courseId} objectId={objectId} />}
        {type === "scormPackage" && (
          <ScormPackageAnalytics location={location} courseId={courseId} objectId={objectId} />
        )}
      </SubTopbar>
    </>
  );
};
